/*
作者：刘清政（llnb）
时间：2021/4/29
作用：
 */

import axios from "axios";
import router from "../router";
import Element from "element-ui"
import cookies from "vue-cookies";

const DEFAULT_TIMEOUT = Number(process.env.VUE_APP_API_TIMEOUT || 30000)

const isRequestAborted = (error) => {
    return error && (
        error.code === 'ERR_CANCELED' ||
        /aborted|canceled|cancelled/i.test(error.message || '')
    )
}

const isTimeoutError = (error) => {
    return error && !isRequestAborted(error) && (
        error.code === 'ECONNABORTED' ||
        /timeout/i.test(error.message || '')
    )
}

const getErrorMessage = (error) => {
    if (isTimeoutError(error)) {
        return '请求超时，请检查网络后重试'
    }
    if (error && error.response && error.response.data && error.response.data.msg) {
        return error.response.data.msg
    }
    if (error && error.response && error.response.status === 401) {
        return '登录状态已失效，请重新登录'
    }
    return '请求服务器异常，请稍后重试'
}

const clip = (value, maxLength = 1200) => {
    if (value === undefined || value === null) {
        return ''
    }
    const text = typeof value === 'string' ? value : JSON.stringify(value)
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text
}

const trackHttp = (event) => {
    if (window.__SEAF_TRACK_HTTP__) {
        window.__SEAF_TRACK_HTTP__(event)
    }
}

//创建请求对象
//指定超时时间，测试环境网络波动时 5 秒过短，容易误判为页面崩溃
//指定请求头中编码格式为application/json
const request = axios.create({
    timeout: DEFAULT_TIMEOUT,
    headers: {
        'Content-Type': "application/json; charset=utf-8;"
    }
})

//在请求发出之前进行拦截，
// 从localStorage中取出token携带在请求头中
request.interceptors.request.use(config => {
    config.metadata = {startedAt: Date.now()}
    config.headers['token'] = cookies.get("token")
    trackHttp({
        phase: 'request',
        method: (config.method || 'get').toUpperCase(),
        url: config.url,
    })
    return config
})

request.interceptors.response.use(
    response => {
        const config = response.config || {}
        trackHttp({
            phase: 'response',
            method: (config.method || 'get').toUpperCase(),
            url: config.url,
            status: response.status,
            duration: config.metadata ? Date.now() - config.metadata.startedAt : undefined,
        })
        return response
    },
    error => {
        error.__handledByHttp = true
        const aborted = isRequestAborted(error)
        if (aborted) {
            error.__ignoreRuntimeReport = true
        }
        const message = getErrorMessage(error)
        const config = error.config || {}
        const response = error.response || {}
        const httpInfo = {
            method: (config.method || 'get').toUpperCase(),
            url: config.url || '',
            status: response.status || '',
            timeout: config.timeout || DEFAULT_TIMEOUT,
            duration: config.metadata ? Date.now() - config.metadata.startedAt : undefined,
            response: clip(response.data),
        }
        trackHttp(Object.assign({phase: 'error'}, httpInfo))
        if (!aborted && window.__SEAF_RECORD_RUNTIME_ERROR__) {
            window.__SEAF_RECORD_RUNTIME_ERROR__({
                source: 'http',
                message,
                info: `${httpInfo.method} ${httpInfo.url} ${httpInfo.status}`.trim(),
                stack: error && error.stack,
                http: httpInfo,
            })
        }
        if (error && error.response && error.response.status === 401) {
            router.push("/login")
        }
        if (!aborted && (!error.config || !error.config.silentError)) {
            Element.Message.error(message, {duration: 5000})
        }
        return Promise.reject(error)
    }
)

export default request
